import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import VehicleHireService from "../services/vehicleHireService";
import StorageService from "../services/StorageService";
import Breadcrumb from "../components/Breadcrumb";
import Loading from "../components/loading";
import ReactPaginate from "react-paginate";
import XLSX from "xlsx-js-style";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import utility from "../utils/utility";
import MessageDialog from "../components/MessageDialog";


export default function ViewVehicleHire() {
  const [hires, setHires] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO (single select)
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const navigate = useNavigate();
  // const messageTimer = useRef(null);

  // useEffect(() => {
  //   fetchHires();
  // }, [currentPage]);

  // const fetchHires = async () => {
  //   setLoading(true);
  //   try {
  //     const companyId = StorageService.activeCompany().companyId;
  //     const res = await VehicleHireService.getByCompanyId(companyId);

  //     const data = res.data || res || [];
  //     setHires(data.sort((a, b) => b.id - a.id));
  //   } catch (err) {
  //     console.error(err);
  //     showMessage("Failed to fetch vehicle hires.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const showMessage = (text, type = "error") => {
  //   setMessage(text);
  //   setMsgType(type);
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  //   messageTimer.current = setTimeout(() => setMessage(""), 4000);
  // };

  // const fetchHires = async () => {
  //   setLoading(true);
  //   try {
  //     const companyId = StorageService.activeCompany().companyId;
  //     const search = searchText.trim().toLowerCase();

  //     const res = search
  //       ? await VehicleHireService.exportVehicleHire(companyId)
  //       : await VehicleHireService.getAll(
  //         companyId,
  //         currentPage,
  //         itemsPerPage
  //       );

  //     let data = res.data || [];

  //     if (search) {
  //       data = data.filter(
  //         (h) =>
  //           h.vehicleName?.toLowerCase().includes(search) ||
  //           h.registrationNo?.toLowerCase().includes(search) ||
  //           h.vehicleType?.toLowerCase().includes(search)
  //       );
  //     }

  //     setHires(search ? data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage) : data);
  //     setPageCount(search ? Math.ceil(data.length / itemsPerPage) : res.totalPages || 0);

  //     } catch (err) {
  //       console.error(err);
  //       showMessage("Failed to fetch vehicle hires.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };


  const fetchHires = async () => {
    setLoading(true);
    try {
      const companyId = StorageService.activeCompany().companyId;
      const search = searchText.trim().toLowerCase();

      const res = search
        ? await VehicleHireService.exportVehicleHire(companyId)
        : await VehicleHireService.getAll(
          companyId,
          currentPage,
          itemsPerPage,
          searchText
        );

      let data = res.data || [];

      if (search) {
        data = data.filter(
          (h) =>
            h.vehicleName?.toLowerCase().includes(search) ||
            h.registrationNo?.toLowerCase().includes(search) ||
            h.vehicleType?.toLowerCase().includes(search)
        );
      }

      setHires(search ? data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage) : data);
      setPageCount(search ? Math.ceil(data.length / itemsPerPage) : res.totalPages || 0);
    } catch (err) {
      console.error(err);
      showMessage("Failed to fetch vehicle hires.");
    } finally {
      setLoading(false);
    }
  };

  const exportExcel = async () => {

    if (!can("canView")) {
      showMessage("No permission", "error");
      return;
    }
    try {
      const company = StorageService.activeCompany();

      const res = await VehicleHireService.exportVehicleHire(company.companyId);

      if (!res?.status || !res.data.length) {
        showMessage("No data to export", "error");
        return;
      }

      const vehicleHires = res.data;

      const wb = XLSX.utils.book_new();
      const ws = {};
      ws["!merges"] = [];

      let row = 0;

      // ✅ STYLES
      const thin = { style: "thin" };
      const thick = { style: "medium" };

      const center = {
        horizontal: "center",
        vertical: "center",
        wrapText: true
      };

      // =========================
      // TITLE
      // =========================
      XLSX.utils.sheet_add_aoa(ws, [["Vehicle Hire Report"]], {
        origin: { r: row, c: 1 }
      });

      ws["!merges"].push({
        s: { r: row, c: 1 },
        e: { r: row, c: 10 }
      });

      const titleCell = XLSX.utils.encode_cell({ r: row, c: 1 });

      ws[titleCell].s = {
        font: { bold: true, sz: 16 },
        alignment: center
      };

      row += 2;

      // =========================
      // HEADER
      // =========================
      const header = [
        "Company",
        "Vehicle",
        "Vehicle Type",
        "Lease Type",
        "Hire Rate",
        "Start Date",
        "End Date",
        "Fuel Borne By",
        "Status"
      ];

      const startRow = row; // ✅ TRACK START

      XLSX.utils.sheet_add_aoa(ws, [header], {
        origin: { r: row, c: 1 }
      });

      header.forEach((_, i) => {
        const cell = XLSX.utils.encode_cell({ r: row, c: i + 1 });

        ws[cell].s = {
          font: { bold: true },
          alignment: center
        };
      });

      row++;

      // =========================
      // DATA
      // =========================
      vehicleHires.forEach((v) => {
        const rowData = [
          v.companyName,
          v.vehicleName,
          v.vehicleType,
          v.leaseType,
          v.vehicleHirerate,
          utility.formatDateDDMMMYYYY(v.startDate),
          utility.formatDateDDMMMYYYY(v.endDate),
          v.fuelBorneBy,
          v.status
        ];

        XLSX.utils.sheet_add_aoa(ws, [rowData], {
          origin: { r: row, c: 1 }
        });

        row++;
      });

      const endRow = row - 1; // ✅ TRACK END

      // =========================
      // APPLY BORDERS 🔥
      // =========================
      const colCount = header.length;

      for (let r = startRow; r <= endRow; r++) {
        for (let c = 1; c <= colCount; c++) {
          const cell = XLSX.utils.encode_cell({ r, c });

          if (!ws[cell]) {
            ws[cell] = { t: "s", v: "" };
          }

          ws[cell].s = ws[cell].s || {};
          ws[cell].s.alignment = center;

          ws[cell].s.border = {
            top: r === startRow ? thick : thin,
            bottom: r === endRow ? thick : thin,
            left: c === 1 ? thick : thin,
            right: c === colCount ? thick : thin
          };
        }
      }

      // =========================
      // COLUMN WIDTH
      // =========================
      ws["!cols"] = [
        { wch: 20 },
        { wch: 20 },
        { wch: 15 },
        { wch: 15 },
        { wch: 12 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 12 }
      ];

      // =========================
      // EXPORT
      // =========================
      XLSX.utils.book_append_sheet(wb, ws, "VehicleHire");

      XLSX.writeFile(wb, "VehicleHire.xlsx");

    } catch (error) {
      console.error(error);
      showMessage("Error exporting data", "error");
    }
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);

    // if (messageTimer.current) clearTimeout(messageTimer.current);

    // messageTimer.current = setTimeout(() => {
    //   setMessage("");
    // }, 4000);
  };

  const { permission, checkView, can } = usePermission(
    ScreenData.Vehicle_Hire,
    showMessage
  );

  useEffect(() => {
    if (permission) {
      if (checkView()) {
        fetchHires();
      }
    }
  }, [currentPage, permission, searchText]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };


  // const filteredHires = hires.filter(
  //   (h) =>
  //     h.vehicleName?.toLowerCase().includes(searchText.toLowerCase()) ||
  //     h.registrationNo?.toLowerCase().includes(searchText.toLowerCase()) ||
  //     h.vehicleType?.toLowerCase().includes(searchText.toLowerCase())
  // );
  const filteredHires = hires;


  const handleSelect = (id) => {
    setSelected(id);
  };

  const handleAdd = () => {
    if (!can("canAdd")) {
      showMessage("No permission", "error");
      return;
    }
    navigate("/cpnl/vehiclehire/add");
  };

  const handleModify = () => {
    if (!can("canModify")) {
      showMessage("No permission", "error");
      return;
    }

    if (!selected) {
      showMessage("Please select one vehicle hire to modify.");
      return;
    }

    navigate(`/cpnl/vehiclehire/add/${selected}`);
  };

  const handleToggleStatus = async (hire) => {
    if (!can("canModify")) {
      showMessage("No permission", "error");
      return;
    }
    const newStatus = hire.status === "Active" ? "Inactive" : "Active";

    if (!window.confirm(`Are you sure you want to change status to ${newStatus}?`))
      return;

    setLoading(true);
    try {
      const res = await VehicleHireService.updateStatus(hire.id, newStatus);
      const msg = res?.message || "Status updated successfully";
      showMessage(msg, "success");
      fetchHires();
    } catch (err) {
      console.error(err);
      const errMsg = err?.response?.data?.message || err?.message || "Error updating status";
      showMessage(errMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  // const formatDate = (dateStr) => {
  //   if (!dateStr) return "-";
  //   const date = new Date(dateStr);
  //   return date.toLocaleDateString("en-GB");
  // };

  const getStatusClass = (status) =>
    status === "Active" ? "bg-success" : "bg-secondary";

  return (
    <>
      <Breadcrumb pageTitle="Vehicle Hire" secondTitle="Vehicle Management" />

      <div className="row">
        <div className="card p-3 bg-white shadow-sm">

          {/* {message && (
            <div
              className={`alert ${
                msgType === "success" ? "alert-success" : "alert-danger"
              } d-flex justify-content-between align-items-center w-100 mb-2 p-2`}
              style={{ borderRadius: "5px" }}
            >
              <span>{message}</span>
              <button type="button" className="btn-close" onClick={closeMessage} />
            </div>
          )} */}

          <MessageDialog
            message={message}
            type={msgType}
            setMessage={setMessage}
            setMsgType={setMsgType}
          />


          {/* <div className="mb-3 pb-2 border-bottom">
            <button
              className="d-inline-flex btn btn-success me-2"
              onClick={handleAdd}
              disabled={loading}
            >
              <i className="ti ti-plus me-1"></i> Add
            </button>

            <button
              className="d-inline-flex btn btn-warning me-2"
              onClick={handleModify}
              disabled={loading}
            >
              <i className="ti ti-pencil me-1"></i> Modify
            </button>
          </div> */}


          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">

            {/* 🔹 SEARCH BOX */}
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Vehicle Hire"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            {/* 🔹 SEARCH BUTTON (optional UI only) */}
            {/* <button
    className="btn btn-primary"
    onClick={() => {}} // no API call needed (live search)
  >
    <i className="ti ti-search"></i> Search
  </button> */}


            <div className="ms-auto d-flex gap-2">

              {can("canAdd") && (
                <button
                  className="d-inline-flex btn btn-success"
                  onClick={handleAdd}
                  disabled={loading}
                >
                  <i className="ti ti-plus me-1"></i> Add
                </button>
              )}

              {can("canModify") && (
                <button
                  className="d-inline-flex btn btn-warning"
                  onClick={handleModify}
                  disabled={loading}
                >
                  <i className="ti ti-pencil me-1"></i> Modify
                </button>
              )}

              {can("canView") && (
                <button
                  className="btn btn-success"
                  onClick={exportExcel}
                >
                  <i className="ti ti-download me-1"></i>
                  Export Excel
                </button>
              )}

            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
              <thead className="table-light">
                <tr>
                  <th>Select</th>
                  <th>Vehicle Type</th>
                  <th>Vehicle</th>
                  <th>Registration No</th>
                  <th>Lease Type</th>
                  <th>Hire Rate (₹)</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Fuel Borne By</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="10" className="text-center py-4">
                      <Loading />
                    </td>
                  </tr>
                )
                  : filteredHires.length > 0 ? (
                    filteredHires.map((hire) => {
                      const isActive = hire.status === "Active";
                      return (
                        <tr key={hire.id}>
                          <td>
                            <input
                              type="radio"
                              name="vehicleHireSelect"
                              disabled={!isActive}
                              checked={selected === hire.id}
                              onChange={() => handleSelect(hire.id)}
                            />
                          </td>

                          <td>{hire.vehicleType || ""}</td>

                          <td>
                            {hire.vehicleName || ""}
                          </td>
                          <td>{hire.registrationNo || "-"}</td>

                          <td>{hire.leaseType || "-"}</td>

                          <td>
                            {hire.vehicleHirerate
                              ? Number(hire.vehicleHirerate).toFixed(2)
                              : "-"}
                          </td>

                          <td>{utility.formatDateDDMMMYYYY(hire.startDate) || "-"}</td>
                          <td>{utility.formatDateDDMMMYYYY(hire.endDate) || "-"}</td>
                          <td>{hire.fuelBorneBy || "-"}</td>

                          <td>
                            <span
                              className={`badge ${getStatusClass(hire.status)}`}
                              onClick={() => handleToggleStatus(hire)}
                              style={{ cursor: "pointer" }}
                            >
                              {hire.status}
                            </span>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center text-muted">
                        No vehicle hires found
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>

            <ReactPaginate
              breakLabel="..."
              nextLabel="Next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="< Previous"
              containerClassName="pagination-container"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
            />
          </div>

        </div>
      </div>
    </>
  );
}
